var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBoltX2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.47389 12.9709C6.33358 13.1328 6.44858 13.3846 6.66281 13.3846H10.5899C10.7542 13.3846 10.8738 13.5403 10.8315 13.699L9.16376 19.953C9.09543 20.2092 9.42056 20.3815 9.59424 20.1811L17.526 11.0291C17.6663 10.8672 17.5513 10.6154 17.3371 10.6154H13.41C13.2457 10.6154 13.1261 10.4597 13.1684 10.301L14.8361 4.04703C14.9044 3.7908 14.5793 3.61848 14.4056 3.81888L6.47389 12.9709ZM15.6878 8.6154L16.7686 4.56235C17.3835 2.25627 14.4574 0.70544 12.8943 2.50902L4.96251 11.661C3.69975 13.1181 4.73472 15.3846 6.66281 15.3846H8.3121L7.23129 19.4377C6.61633 21.7438 9.54251 23.2946 11.1056 21.491L19.0374 12.339C20.3001 10.882 19.2651 8.6154 17.3371 8.6154H15.6878Z",
    className: "Icon-fill-color"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoltX2);
export default __webpack_public_path__ + "static/media/BoltX2.442d84052f2999914c0c474fe87b3fe6.svg";
export { ForwardRef as ReactComponent };